import Cookies from '../_vendors/js.cookie';

export function theme_cookieConsentHandler() {

	if (typeof cookie_banner === 'undefined') {
		return;
	}

	const DEFAULT_COOKIE_NAME = cookie_banner.TBCCM_SLUG;

	function theme_cookie_banner() {

		if (typeof cookie_banner === 'undefined' || Cookies.get(DEFAULT_COOKIE_NAME) || !DEFAULT_COOKIE_NAME) {
			return;
		}

		if (cookie_banner.TBCCM_SHOW === '0') {
			return;
		}

		const wrapper = document.createElement('div');
		wrapper.className = 'cookie--wrapper cookie--pop';

		const overlay = document.createElement('div');
		overlay.className = 'cookie--overlay';

		const banner = document.createElement('div');
		banner.className = 'cookie--box';

		const bannerInner = `
			<div class="cookie--container">
				<div class="cookie--body"></div>
				<div class="cookie--footer"></div>
			</div>
		`;
		banner.innerHTML = bannerInner;

		document.body.append(wrapper);
		wrapper.append(banner, overlay);

		const body = banner.querySelector('.cookie--body');
		body.innerHTML = `
			<h3>${cookie_banner.TBCCM_BANNER.TITLE}</h3>
			<p>${cookie_banner.TBCCM_BANNER.TEXT}</p>
		`;

		const btnGroup = document.createElement('div');
		btnGroup.className = 'cookie-button-group';
		body.append(btnGroup);

		const acceptBtn = document.createElement('button');
		acceptBtn.type = 'submit';
		acceptBtn.id = 'cookie_accept_all';
		acceptBtn.className = 'button button-primary';
		acceptBtn.textContent = cookie_banner.TBCCM_BANNER.BTN_ACPT;
		btnGroup.append(acceptBtn);

		if (cookie_banner.TBCCM_BANNER.BTN_DIS) {
			const declineBtn = document.createElement('button');
			declineBtn.type = 'button';
			declineBtn.id = 'cookie_decline_all';
			declineBtn.className = 'button button-primary';
			declineBtn.textContent = cookie_banner.TBCCM_BANNER.BTN_DIS;
			btnGroup.append(declineBtn);
		}

		if (cookie_banner.TBCCM_SET_ON === '1') {
			const settingsBtn = document.createElement('button');
			settingsBtn.id = 'cookie_settings';
			settingsBtn.className = 'button button-secondary';
			settingsBtn.setAttribute('aria-expanded', 'false');
			settingsBtn.setAttribute('aria-controls', 'cookiesetting');
			settingsBtn.textContent = cookie_banner.TBCCM_BANNER.BTN_SET;
			btnGroup.append(settingsBtn);
		}

		if (cookie_banner.TBCCM_PRIVACY.URL) {
			const footer = banner.querySelector('.cookie--footer');
			const privacyLink = document.createElement('a');
			privacyLink.href = `${cookie_banner.TBCCM_PRIVACY.URL}#cookiesetting_inline`;
			privacyLink.rel = 'nofollow';
			privacyLink.textContent = cookie_banner.TBCCM_PRIVACY.TEXT;
			footer.append(privacyLink);
		}

		if (cookie_banner.TBCCM_IMPRINT.URL) {
			const footer = banner.querySelector('.cookie--footer');
			const imprintLink = document.createElement('a');
			imprintLink.href = cookie_banner.TBCCM_IMPRINT.URL;
			imprintLink.rel = 'nofollow';
			imprintLink.textContent = cookie_banner.TBCCM_IMPRINT.TEXT;
			footer.append(imprintLink);
		}

		if (cookie_banner.TBCCM_SET_ON !== '0') {
			theme_cookie_consent();
		}
	}

	function theme_cookie_consent() {
		const consent = document.createElement('div');
		consent.id = 'cookiesetting';
		consent.className = 'cookie--setting';
		document.querySelector('.cookie--pop > .cookie--box').after(consent);
		theme_cookie_consent_form(consent);
	}

	function theme_cookie_consent_form(consent) {
		const consentInner = `
			<div class="cookie--container">
				<div class="cookie--body"></div>
				<div class="cookie--form">
					<form id="cookie_form"></form>
				</div>
			</div>
		`;
		consent.innerHTML = consentInner;

		const body = consent.querySelector('.cookie--body');
		body.innerHTML = `
			<h3>${cookie_banner.TBCCM_SET.TITLE}</h3>
			<p>${cookie_banner.TBCCM_SET.TEXT}</p>
		`;

		const btnGroup = document.createElement('div');
		btnGroup.className = 'cookie-button-group';
		body.append(btnGroup);

		const acceptBtn = document.createElement('button');
		acceptBtn.type = 'submit';
		acceptBtn.id = 'cookie_accept_all_setting';
		acceptBtn.className = 'button button-primary';
		acceptBtn.textContent = cookie_banner.TBCCM_SET.BTN_ACPT;
		btnGroup.append(acceptBtn);

		const footer = document.createElement('div');
		footer.className = 'cookie--footer';
		footer.innerHTML = `
			<button type="button" id="cookie_save_setting" class="button button-secondary">${cookie_banner.TBCCM_SET.BTN_SAVE}</button>
			<button type="button" id="cookiesetting_close" class="close"></button>
		`;
		consent.querySelector('.cookie--container').append(footer);


		Object.entries(cookie_banner.TBCCM_COOKIES).forEach( ([key, value]) => {

			if (value.COOKIES.length) {
				const rowGroup = document.createElement('div');
				rowGroup.className = 'cookie--setting-group';
				rowGroup.dataset.group = key;

				const groupHeader = document.createElement('div');
				groupHeader.className = 'cookie--group-header';
				const groupTitle = document.createElement('div');
				groupTitle.className = 'cookie-group-title';
				groupTitle.textContent = value.NAME;

				const toggleBtn = document.createElement('button');
				toggleBtn.className = 'cookie-btn-toggle';
				toggleBtn.setAttribute('aria-expanded', 'false');
				toggleBtn.setAttribute('aria-controls', `info_${key}`);
				toggleBtn.innerHTML = `<span class="screen-reader-text">${cookie_banner.TBCCM_TRANS.INFO}</span>`;

				const switchLabel = document.createElement('label');
				switchLabel.className = `cookie-btn-switch${value.CHECKED ? ' cookie-btn-switch-active' : ''}`;
				const checkbox = document.createElement('input');
				checkbox.type = 'checkbox';
				checkbox.name = `cookie-group-${key}`;
				checkbox.value = key;
				checkbox.checked = Boolean(value.CHECKED);
				checkbox.disabled = key === '1';
				const switchSlider = document.createElement('span');
				switchSlider.className = 'cookie-slider';
				switchLabel.append(checkbox, switchSlider);

				groupHeader.append(groupTitle, toggleBtn, switchLabel);
				rowGroup.append(groupHeader);

				const groupBody = document.createElement('div');
				groupBody.id = `info_${key}`;
				groupBody.className = 'cookie--group-body';
				groupBody.role = 'region';
				groupBody.ariaHidden = true;
				groupBody.innerHTML = `<p>${value.DESCR}</p>`;
				rowGroup.append(groupBody);

				document.querySelector('form#cookie_form').append(rowGroup);
			}
		});
	}

	function theme_inline_cookie_consent() {
		const content = document.getElementById('cookiesetting_inline');

		if (content) {
			content.innerHTML += `
				<hr>
				<p><strong>${cookie_banner.TBCCM_CONSENT_SET}</strong></p>
				<p><button id="cookie_settings_editor" class="button button-secondary">${cookie_banner.TBCCM_BANNER.BTN_SET}</button></p>
				<hr>
			`;

			Object.entries(cookie_banner.TBCCM_COOKIES).forEach( ([key, value]) => {

				if (value.COOKIES.length) {
					const row = document.createElement('div');
					row.className = 'cookie--row';
					content.append(row);

					const title = document.createElement('h4');
					title.textContent = value.NAME;
					row.append(title);

					const description = document.createElement('p');
					description.innerHTML = value.DESCR;
					row.append(description);

					value.COOKIES.forEach(v => {
						const rowGroup = document.createElement('div');
						rowGroup.className = 'cookie--group';
						row.append(rowGroup);

						const smallText = document.createElement('p');
						smallText.className = 'small';
						smallText.innerHTML = `
							<strong>${cookie_banner.TBCCM_TRANS.NAME}:</strong> ${v.name}<br>
							<strong>${cookie_banner.TBCCM_TRANS.CNAME}:</strong> ${v.cookie_name}<br>
							<strong>${cookie_banner.TBCCM_TRANS.PROVIDER}:</strong> ${v.provider}<br>
							<strong>${cookie_banner.TBCCM_TRANS.PURPOSE}:</strong> ${v.purpose}<br>
							${v.privacy_url.length ? `<strong>${cookie_banner.TBCCM_TRANS.PRIVACY}:</strong> ${v.privacy_url}<br>` : ''}
							<strong>${cookie_banner.TBCCM_TRANS.RUNTIME}:</strong> ${v.cookie_time}<br>
						`;
						rowGroup.append(smallText);
					});
				}
			});
		}
	}

	theme_cookie_banner();
	theme_inline_cookie_consent();

	document.body.addEventListener( "click", (e) => {

		if (e.target.matches('.cookie-btn-toggle')) {
			e.preventDefault();
			const infoId = e.target.getAttribute('aria-controls');
			const infoElement = document.getElementById(infoId);
			let isExpanded = e.target.getAttribute('aria-controls') === 'true' ? 'false' : 'true';
			e.target.setAttribute('aria-expanded', e.target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
			infoElement.setAttribute('aria-hidden',  e.target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
		}

		if (e.target.matches('.cookie-btn-switch input[type="checkbox"]')) {
			const stat = e.target.parentElement;
			stat.classList.toggle('cookie-btn-switch-active');
			e.target.checked = e.target.checked !== false;
		}

		if (e.target.matches('#cookie_settings')) {
			document.querySelector('.cookie--box').style.display = 'none';
			document.querySelector('.cookie--setting').classList.toggle('_visible');
			e.target.setAttribute('aria-expanded', e.target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
			return false;
		}

		if (e.target.matches('.menu-item.open-consent-manager > a, #cookie_settings_editor')) {
			e.preventDefault();
			if (document.getElementById('cookiesetting')) {
				return;
			}
			const wrapper = document.createElement('div');
			wrapper.className = 'cookie--wrapper cookie--pop';
			const overlay = document.createElement('div');
			overlay.className = 'cookie--overlay';
			const consent = document.createElement('div');
			consent.id = 'cookiesetting';
			consent.className = 'cookie--setting';

			if (cookie_banner.TBCCM_SET_ON !== '0') {
				document.body.append(wrapper);
				wrapper.append(consent, overlay);
				theme_cookie_consent_form(consent);
			}

			if (document.querySelector('.cookie--setting')) {
				setTimeout(() => {
					document.querySelector('.cookie--setting').classList.add('_visible');
				}, 100);
			}
		}

		if (e.target.matches('#cookiesetting_close')) {
			if (document.querySelector('.cookie--box')) {
				document.querySelector('.cookie--box').style.display = 'block';
				document.querySelector('.cookie--setting').classList.toggle('_visible');
				document.getElementById('cookie_settings').setAttribute('aria-expanded', 'false');
			}
			else {
				document.querySelector('.cookie--setting').classList.remove('_visible');
				document.querySelector('.cookie--overlay').style.display = 'none';
				document.querySelector('.cookie--setting').addEventListener('transitionend', () => {
					document.querySelector('.cookie--wrapper').remove();
				});
			}
			return false;
		}

		if ( e.target.closest('a.js-load-oembed') ) {
			e.preventDefault();
			const btn = e.target.closest('a');
			const parent = btn.closest('.cookie-oembed-notice');
			const spinner = document.createElement('span');
			spinner.className = 'oembed-spinner';

			btn.classList.toggle('cookie-load-switch-active');

			setTimeout( () => {
				btn.parentNode.replaceChildren(spinner);
			}, 250);

			fetch( cookie_banner.AJAXURL, {
				method: 'POST',
				body: new URLSearchParams({
					action: 'load_oembed',
					embed: btn.dataset.oembed,
					security: cookie_banner.AJAXNONCE
				}),
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
			.then( r => r.json())
			.then( response => {

				if ( response.success ) {
					parent.outerHTML = response.data.html;
				}
				else {
					parent.innerHTML = `<p class="cookie-oembed-error">${response.data.message}</p>`;
				}

			});
		}

		if (e.target.matches('#cookie_accept_all, #cookie_accept_all_setting')) {
			e.preventDefault();
			const cookie_IDs = [];
			const checkboxes = document.querySelectorAll('#cookie_form input[type="checkbox"]');
			checkboxes.forEach(checkbox => {
				cookie_IDs.push(checkbox.value);
			});
			save_cookie_consent( cookie_IDs );
		}

		if (e.target.matches('#cookie_save_setting')) {
			e.preventDefault();
			const cookie_IDs = [];
			const checkboxes = document.querySelectorAll('#cookie_form input[type="checkbox"]');
			checkboxes.forEach(checkbox => {
				if (checkbox.checked) {
					cookie_IDs.push(checkbox.value);
				}
			});
			save_cookie_consent( cookie_IDs );
		}

		if (e.target.matches('#cookie_decline_all')) {
			e.preventDefault();
			const cookie_IDs = [1];
			save_cookie_consent( cookie_IDs );
		}
	});

	function set_the_cookies( data ) {
		const today = new Date();
		const todayDate = `${today.getDate()}.${today.getMonth() + 1}.${today.getFullYear()}`;
		const todayTime = `${today.getHours()}:${today.getMinutes()}`;
		const todayDateTime = [todayDate, todayTime];
		const value = {
			'consent': todayDateTime,
			'cat_ids': data.cats,
			'id': data.id
		};

		const jsonString = JSON.stringify(value);
		const btoaString = window.btoa(jsonString);

		if ( value && data.expires ) {
			Cookies.set(DEFAULT_COOKIE_NAME, btoaString, { expires: parseInt(data.expires) });
		}
	}

	function save_cookie_consent( id_array ) {

		if ( ! id_array ) {
			location.reload(true);
		}

		fetch( cookie_banner.AJAXURL, {
			method: 'POST',
			body: new URLSearchParams({
				action: 'consent_entry',
				ids: id_array,
				security: cookie_banner.AJAXNONCE
			}),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
		.then( r => r.json())
		.then( response => {

			if ( response.success ) {
				set_the_cookies(response.data);
				location.reload(true);
			}
			else {
				// location.reload(true);
				console.log(response.data.message);
			}

		});

	}
}
